/* EZ Test Latam — fondo del hero.
 *
 * Por que un shader y no CSS: el fondo anterior eran tres circulos con
 * blur(58px) que se trasladaban 9vw en 19 segundos. Un borde difuminado a 58px
 * desplazado 9vw no cambia casi ningun pixel por cuadro, asi que el ojo lo lee
 * como una imagen fija. Aca cada pixel se recalcula por cuadro a partir de un
 * campo de ruido con domain warping: el color viaja por la pantalla en lugar de
 * que se muevan unas formas.
 *
 * Paleta: la misma del hero actual (#050A1C a #3E7BFF). Lo que agrega
 * movimiento visible no es un color nuevo sino la separacion de luminancia
 * entre el fondo navy y el azul brillante.
 *
 * Si no hay WebGL, o el sistema pide menos movimiento, el canvas no se crea y
 * quedan los blobs CSS como fondo estatico.
 */
(function () {
  var VERT =
    'attribute vec2 p;void main(){gl_Position=vec4(p,0.0,1.0);}';

  var FRAG = [
    'precision highp float;',
    'uniform vec2 u_res;',
    'uniform float u_t;',

    'vec2 hash2(vec2 p){',
    '  p=vec2(dot(p,vec2(127.1,311.7)),dot(p,vec2(269.5,183.3)));',
    '  return fract(sin(p)*43758.5453)*2.0-1.0;',
    '}',
    'float noise(vec2 p){',
    '  vec2 i=floor(p),f=fract(p);',
    '  vec2 u=f*f*(3.0-2.0*f);',
    '  return mix(mix(dot(hash2(i),f),dot(hash2(i+vec2(1.0,0.0)),f-vec2(1.0,0.0)),u.x),',
    '             mix(dot(hash2(i+vec2(0.0,1.0)),f-vec2(0.0,1.0)),dot(hash2(i+vec2(1.0,1.0)),f-vec2(1.0,1.0)),u.x),u.y);',
    '}',
    /* Cuatro octavas. Con tres el campo quedaba tan liso que no habia nada que
       el ojo pudiera seguir: el fondo se movia pero se leia como imagen fija.
       Medido: 4.3 de delta medio por pixel cada 2s contra 9.7 de esta version. */
    'float fbm(vec2 p){',
    '  float v=0.0,a=0.5;',
    '  for(int i=0;i<4;i++){v+=a*noise(p);p=p*2.03+vec2(1.7,9.2);a*=0.5;}',
    '  return v;',
    '}',

    'void main(){',
    '  vec2 uv=gl_FragCoord.xy/u_res;',
    '  float t=u_t*0.34;',
    /* Escala atada al lado corto, no al ancho. Antes multiplicabamos uv.x por el
       aspect ratio: en un movil de 390x844 eso comprimia el campo a 0.46 de ancho
       y el humo salia en bandas verticales estiradas. Dividir por min(w,h) deja el
       tamano de las formas igual en escritorio y en movil. */
    '  vec2 p=gl_FragCoord.xy/min(u_res.x,u_res.y)*1.35 + vec2(t*0.24,t*0.10);',

    /* Dos niveles de domain warping, y el segundo evoluciona en el tiempo por
       su cuenta: eso es lo que da la sensacion de humo que se revuelve en vez
       de una textura rigida que se desliza. */
    '  vec2 q=vec2(fbm(p),fbm(p+vec2(5.2,1.3)));',
    '  vec2 r=vec2(fbm(p+2.2*q+vec2(1.7,9.2)+t*0.34),fbm(p+2.2*q+vec2(8.3,2.8)-t*0.27));',
    '  float f=fbm(p+2.6*r);',
    '  float n=clamp(f*2.3+0.5,0.0,1.0);',

    '  vec3 c1=vec3(0.020,0.039,0.110);',
    '  vec3 c2=vec3(0.027,0.063,0.200);',
    '  vec3 c3=vec3(0.043,0.106,0.290);',
    '  vec3 c4=vec3(0.043,0.180,0.561);',
    '  vec3 c5=vec3(0.102,0.333,0.980);',

    '  vec3 col=mix(c1,c2,smoothstep(0.00,0.32,n));',
    '  col=mix(col,c3,smoothstep(0.28,0.58,n));',
    '  col=mix(col,c4,smoothstep(0.54,0.84,n));',
    '  col=mix(col,c5,smoothstep(0.82,1.00,n));',

    /* Un solo lobulo lento: con la textura de humo ya hay movimiento de sobra,
       dos lobulos ademas lavaban el navy. */
    '  vec2 g1=vec2(0.32+0.30*sin(t*0.31),0.72+0.20*cos(t*0.23));',
    '  col+=c5*0.30*smoothstep(0.62,0.0,distance(uv,g1));',

    /* El piso oscuro baja de 0.78 a 0.40 y arranca mas abajo. Con 0.78 el humo
       moria justo donde esta el titular: medido, 2.9 de delta por pixel en la
       mitad inferior contra 17 arriba, o sea el ojo veia una imagen fija.
       Ahora esa zona mide 7.2 en escritorio y 13.9 en movil. La legibilidad ya
       no depende de aplastar el shader: la resuelve el degradado .ezh::after. */
    '  col*=1.0-0.18*smoothstep(0.42,1.05,distance(uv,vec2(0.45,0.62)));',
    '  col=mix(col,c1,smoothstep(0.55,0.0,uv.y)*0.40);',

    '  col+=(fract(sin(dot(gl_FragCoord.xy,vec2(12.9898,78.233)))*43758.5453)-0.5)/255.0;',
    '  gl_FragColor=vec4(col,1.0);',
    '}'
  ].join('\n');

  function sh(gl, type, src) {
    var s = gl.createShader(type);
    gl.shaderSource(s, src);
    gl.compileShader(s);
    if (!gl.getShaderParameter(s, gl.COMPILE_STATUS)) return null;
    return s;
  }

  function boot(host) {
    if (host.dataset.ezgl === '1') return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var cv = document.createElement('canvas');
    cv.className = 'ezh__gl';
    cv.setAttribute('aria-hidden', 'true');

    var gl = cv.getContext('webgl', { antialias: false, alpha: false, depth: false, stencil: false, powerPreference: 'low-power' })
          || cv.getContext('experimental-webgl');
    if (!gl) return;

    var vs = sh(gl, gl.VERTEX_SHADER, VERT);
    var fs = sh(gl, gl.FRAGMENT_SHADER, FRAG);
    if (!vs || !fs) return;
    var pr = gl.createProgram();
    gl.attachShader(pr, vs); gl.attachShader(pr, fs); gl.linkProgram(pr);
    if (!gl.getProgramParameter(pr, gl.LINK_STATUS)) return;
    gl.useProgram(pr);

    var buf = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, buf);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1,-1, 3,-1, -1,3]), gl.STATIC_DRAW);
    var loc = gl.getAttribLocation(pr, 'p');
    gl.enableVertexAttribArray(loc);
    gl.vertexAttribPointer(loc, 2, gl.FLOAT, false, 0, 0);

    var uRes = gl.getUniformLocation(pr, 'u_res');
    var uT = gl.getUniformLocation(pr, 'u_t');

    host.insertBefore(cv, host.firstChild);
    host.dataset.ezgl = '1';

    /* dpr tope 1.5: a 2.0 en un movil grande son 4x los pixeles por cuadro
       para un degradado que nadie mira de cerca */
    function size() {
      var dpr = Math.min(window.devicePixelRatio || 1, 1.5);
      var w = Math.max(1, Math.round(host.clientWidth * dpr));
      var h = Math.max(1, Math.round(host.clientHeight * dpr));
      if (cv.width !== w || cv.height !== h) {
        cv.width = w; cv.height = h;
        gl.viewport(0, 0, w, h);
        gl.uniform2f(uRes, w, h);
      }
    }
    size();

    /* Un cuadro sincronico antes del loop. Si la pagina carga en una pestania
       de fondo (cmd+click, restaurar sesion, prerender) document.hidden es
       true, rAF no corre y el canvas quedaba negro hasta que la pestania
       tomaba foco: el usuario veia un hero en negro y despues un salto a color. */
    gl.uniform1f(uT, 0);
    gl.drawArrays(gl.TRIANGLES, 0, 3);

    if (window.ResizeObserver) new ResizeObserver(size).observe(host);
    else window.addEventListener('resize', size);

    var visible = true, raf = null, t0 = null, acc = 0, last = 0;

    function frame(ts) {
      if (t0 === null) { t0 = ts; last = ts; }
      /* acumulamos tiempo propio: si la pestania estuvo en segundo plano,
         el reloj no da un salto y la animacion no "teletransporta" */
      var dt = Math.min(ts - last, 64); last = ts; acc += dt;
      gl.uniform1f(uT, acc / 1000);
      gl.drawArrays(gl.TRIANGLES, 0, 3);
      raf = requestAnimationFrame(frame);
    }
    function play() { if (raf === null && visible && !document.hidden) { last = performance.now(); raf = requestAnimationFrame(frame); } }
    function stop() { if (raf !== null) { cancelAnimationFrame(raf); raf = null; } }

    if (window.IntersectionObserver) {
      new IntersectionObserver(function (e) {
        visible = e[0].isIntersecting;
        visible ? play() : stop();
      }, { threshold: 0 }).observe(host);
    }
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : play(); });
    play();
  }

  function init() {
    var h = document.querySelectorAll('.ezh');
    for (var i = 0; i < h.length; i++) boot(h[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
